<template>
    <div class="context" id="page">
        <div class="header" id="header">
            <div class="search_box">
                <el-form :model="searchForm"
                         class="search_form"
                         size="small">
                    <el-form-item label="标题:">
                        <div class="radio_box">
                            <el-input class="width_220"
                                      @change="getTableData()"
                                      placeholder="请输入文章标题"
                                      clearable
                                      v-model="searchForm.input">
                            </el-input>
                            <div class="search_btn">
                                <el-button type="primary"
                                           @click="getTableData()">
                                    搜索
                                </el-button>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item label="分类:">
                        <div class="input_box">
                            <div :class="searchForm.classification === ''?'actived_btn':''"
                                 @click="clearSearch('classification')"
                                 class="btn">不限
                            </div>
                            <div v-for="(item, index) in classifyList"
                                 :key="index"
                                 :class="searchForm.classification === item.value?'actived_btn':''"
                                 @click="changeCell(item.value, 'classification')"
                                 class="btn">
                                {{item.value}}
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item label="标签:">
                        <div class="check_box">
                            <div class="all_check">
                                <el-checkbox :indeterminate="isIndeterminate"
                                             v-model="checkAll"
                                             @change="handleCheckAllChange">
                                    全选
                                </el-checkbox>
                            </div>
                            <div class="check_btn">
                                <el-checkbox-group v-model="searchForm.tags"
                                                   @change="handleCheckedCitiesChange">
                                    <el-checkbox v-for="(item, index) in tag_list"
                                                 :label="item"
                                                 :key="index">
                                        {{item}}
                                    </el-checkbox>
                                </el-checkbox-group>
                            </div>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <div class="btn_box">
                <div class="btn">
                    <el-button size="small"
                               :loading="sync_loading"
                               style="width: 70px"
                               @click="updateText">同步
                    </el-button>
                </div>
                <div class="text">
                    <div>已同步到：{{synchronization.sync_time}}</div>
                    <div v-if="!first_update">
                        本次同步{{synchronization.new_count}}篇文章，{{synchronization.update_count}}篇更新
                    </div>
                </div>
            </div>
        </div>
        <div class="table_box" :style="{height: tableHeight + 'px'}">
            <el-card shadow="never"
                     v-for="(item, index) in tableData"
                     :key="index"
                     class="card_item">
                <div class="img_box">
                    <img :src="showImgUrl(item)" alt="">
                </div>
                <div class="title">{{item.title}}</div>
                <div class="text">{{item.digest}}</div>
                <div class="flex_box date">
                    <div>{{item.update_time}}</div>
                    <el-popover
                            placement="left"
                            width="200"
                            trigger="click">
                        <div class="qrcode" style="height: 200px">
                            <vue-qr :logoSrc="imageUrl"
                                    :text="item.url"
                                    :size="200"></vue-qr>
                        </div>
                        <span slot="reference"
                              style="cursor: pointer"
                              class="iconfont icon-erweima"></span>
                    </el-popover>
                </div>
                <div class="flex_box">
                    <div class="title_f">分类：</div>
                    <div class="text_f select">

                        <el-dropdown trigger="click"
                                     @command="(com) => select_class(com, item, index)">
                                <span v-if="item.cate" class="el-dropdown-link">
                                    {{item.cate}}
                                    <i class="el-icon-arrow-down el-icon--right"></i>
                                </span>
                            <span v-else class="el-dropdown-link add_class">+</span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item v-for="(items, indexs) in classifyList"
                                                  :command="items.value"
                                                  :key="indexs">
                                    {{items.value}}
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
                <div class="flex_box">
                    <div class="title_f">标签：</div>
                    <div class="text_f tags">
                        <el-tag
                                :key="tag"
                                v-for="tag in item.tag_list"
                                closable
                                size="small"
                                class="tag_item"
                                :disable-transitions="false"
                                @close="handleClose(tag, item, index)">
                            {{tag}}
                        </el-tag>
                        <el-input
                                class="input-new-tag"
                                v-if="item.inputVisible"
                                v-model="item.inputValue"
                                size="mini"
                                @input="changeInput"
                                @change="handleInputConfirm(item, index)"
                        >
                        </el-input>
                        <el-button v-else
                                   class="button-new-tag"
                                   size="mini"
                                   @click="showInput(item, index)">+ 新标签
                        </el-button>
                    </div>
                </div>
                <div class="flex_box bottom_flex">
                    <div class="title_f">积分：</div>
                    <div class="text_f input_num"
                         v-if="!item.showScoreEdit"
                         @click="openScoreEdit(item)">
                        <span>{{item.score || '默认'}}</span>
                    </div>
                    <div class="text_f input_num" v-else>
                        <el-input-number v-model="item.score"
                                         class="width_100"
                                         controls-position="right"
                                         size="mini"
                                         :max="100"
                                         :min="1"></el-input-number>
                        <el-button size="mini"
                                   type="primary"
                                   plain
                                   style="margin-left: 5px"
                                   @click="changeScore(item)">
                            确定
                        </el-button>
                    </div>
                </div>
            </el-card>
        </div>
        <div class="bottom_page" id="bottom_page">
            <page-view @getTableList="handleCurrentChange"
                       :currentPage="currentPage"
                       :pageSize="pageSize"
                       :total="total"></page-view>
        </div>
    </div>
</template>

<script>
    import {mapState, mapMutations} from 'vuex'
    import {clone} from "@/global/utils";
    import {langRequest} from "../../api/index"
    import vueQr from 'vue-qr'

    export default {
        name: "courseView",
        components: {
            vueQr,
        },
        data() {
            return {
                imageUrl: '',
                tableHeight: 0,
                searchForm: {
                    input: '',
                    classification: '',
                    tags: []
                },
                tag_list: [],
                isIndeterminate: false,
                checkAll: false,

                tableData: [],

                total: 0,
                currentPage: 1,
                pageSize: 10,

                synchronization: {}, // 同步信息
                sync_loading: false,
                first_update: true,
            }
        },
        computed: {
            ...mapState('comInformationData', [
                'classifyList',
            ]),
        },
        mounted() {
            this.getTagList();
            this.getTableData();
            this.getUpdateTime()
        },
        methods: {
            getTableHeight() {
                let page_h = document.getElementById('page').offsetHeight;
                let header_h = document.getElementById('header').offsetHeight;
                let bottom_h = document.getElementById('bottom_page').offsetHeight;
                this.tableHeight = page_h - header_h - bottom_h;
            },
            getTagList() {
                this.httpGet('/paper/tag').then(res => {
                    this.tag_list = res.data;
                    this.$nextTick(() => {
                        this.getTableHeight()
                    })
                })
            },
            handleCheckAllChange(val) {
                this.searchForm.tags = val ? this.tag_list : [];
                this.isIndeterminate = false;
                this.getTableData()
            },
            handleCheckedCitiesChange(value) {
                let checkedCount = value.length;
                this.checkAll = checkedCount === this.tag_list.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.tag_list.length;
                this.getTableData()
            },

            showImgUrl(item) {
                return item.thumb_file_path_url
            },
            clearSearch(val) {
                this.searchForm[val] = '';
                this.getTableData()
            },
            changeCell(item, val) {
                this.searchForm[val] = item;
                this.getTableData()
            },

            getUpdateTime() {
                this.httpGet('/paper/last_sync').then(res => {
                    this.synchronization = res.data;
                    this.synchronization.sync_time = this.synchronization.sync_time.slice(0, 19);
                    this.first_update = true;
                })
            },
            updateText() {
                //    同步
                this.sync_loading = true;
                let params = {
                    type: 'GET',
                    time: 1000 * 300,
                    data: {}
                };
                langRequest('/paper/sync', params).then(res => {
                    this.synchronization = res.data;
                    this.synchronization.sync_time = this.synchronization.sync_time.slice(0, 19);
                    this.sync_loading = false;
                    this.first_update = false;
                })
            },

            handleCurrentChange(val) {
                this.getTableData(val)
            },
            getTableData(val = 1) {
                let params = {
                    page: val,
                    page_size: this.pageSize,
                    cates: this.searchForm.classification,
                    name: this.searchForm.input,
                    tags: this.searchForm.tags
                };
                this.httpPost('/paper/list', params).then(res => {
                    this.tableData = res.data.data_list;
                    this.tableData.map(v => {
                        v.inputVisible = false;
                        v.inputValue = '';
                    });
                    this.total = res.data.total;
                    this.$nextTick(() => {
                        this.currentPage = val;
                    })
                })
            },
            lookRow(row) {
            },

            select_class(items, item, index) {
                console.log(item, '286');
                let params = {
                    cate: items
                };
                this.httpPost(`/paper/${item.paper_id}`, params).then(res => {
                    item.cate = items;
                    this.$forceUpdate();
                })
            },
            handleClose(tag, item, index) {
                item.tag_list.splice(item.tag_list.indexOf(tag), 1);
                this.submitTags(item, 'del')
            },
            openScoreEdit(item) {
                item.showScoreEdit = true;
                this.$forceUpdate()
            },

            changeScore(item) {
                let params = {
                    score: item.score
                };
                this.httpPost(`/paper/${item.paper_id}`, params).then(res => {
                    item.showScoreEdit = false;
                    this.$forceUpdate();
                })
            },

            showInput(item, index) {
                console.log('saveTagInput' + index, '235');
                item.inputVisible = true;
                this.$forceUpdate();
                // this.$nextTick(_ => {
                //     this.$refs['saveTagInput'+index].$refs.input.focus();
                // });
            },
            changeInput() {
                this.$forceUpdate()
            },
            handleInputConfirm(item, index) {
                let inputValue = item.inputValue;
                if (inputValue) {
                    item.tag_list.push(inputValue);
                }
                item.inputVisible = false;
                item.inputValue = '';
                this.submitTags(item)
            },
            submitTags(item, type = '') {
                let params = {
                    tags: item.tag_list
                };
                this.httpPost(`/paper/${item.paper_id}`, params).then(res => {
                    this.$forceUpdate();
                    this.getTagList();
                    if (type === 'del') {
                        this.searchForm.tags = [];
                        this.isIndeterminate = false;
                        this.checkAll = false;
                    }
                }).catch(err => {
                    if (err.code === 1002) {
                        this.$message.warning(err.msg);
                        item.tag_list.splice(item.tag_list.length - 1, 1)
                    }
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    $view_background: rgb(246, 247, 248);
    $btn_border: rgb(246, 247, 248);
    .context {
        width: 100%;
        height: 100%;
        background: $view_background;
        position: relative;
        display: flex;
        flex-flow: column;

        .header {
            display: flex;
            .search_box {
                flex: 1;
                padding: 5px 10px;
                box-sizing: border-box;
                .radio_box {
                    display: flex;
                    line-height: 30px;
                    .search_btn {
                        padding-left: 15px;
                    }
                }
                .input_box {
                    display: flex;
                    flex-flow: wrap;
                    .btn {
                        height: 25px;
                        line-height: 25px;
                        font-size: .875rem;
                        padding: 0 10px;
                        box-sizing: border-box;
                        margin: 7px 10px;
                        cursor: pointer;
                        color: #606266;
                    }
                    .actived_btn {
                        box-sizing: border-box;
                        border: 1px solid #38adff;
                        border-radius: 3px;
                    }
                }
                .check_box {
                    display: flex;
                    .all_check {
                        flex: 0 0 80px;
                    }
                    .check_btn {
                        flex: 1;
                    }
                }
            }
            .btn_box {
                flex: 0 0 300px;
                display: flex;
                padding: 10px 0;
                box-sizing: border-box;
                .btn {
                    flex: 0 0 80px;
                }
                .text {
                    flex: 1;
                    line-height: 35px;
                    color: #606266;
                    font-size: .875rem;
                }
            }
        }
        .table_box {
            flex: 1;
            width: 100%;
            padding: 0 10px;
            overflow: hidden;
            overflow-y: auto;
            box-sizing: border-box;
            border-bottom: 1px solid #ddd;
            display: flex;
            flex-wrap: wrap;
            align-items: flex-start;
            .card_item {
                width: 320px;
                min-height: 360px;
                position: relative;
                z-index: 1;
                margin: 0 5px 5px 0;
                line-height: 30px;
                .img_box {
                    width: 100%;
                    height: 180px;
                    border-bottom: 1px solid #ccc;
                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
                .title {
                    padding: 0 10px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                .text {
                    font-size: 0.875rem;
                    color: #8d8d8d;
                    padding: 0 10px;
                    height: 60px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                }
                .flex_box {
                    display: flex;
                    justify-content: space-between;
                    padding: 0 10px;
                    font-size: 0.875rem;
                    color: #8d8d8d;
                    .title_f {
                        flex: 0 0 60px;
                    }
                    .text_f {
                        flex: 1;
                    }
                    .select {
                        .add_class {
                            font-size: 1.125rem;
                            cursor: pointer;
                            padding: 0 5px;
                            border: 1px solid #8d8d8d;
                            border-radius: 3px;
                            box-sizing: border-box;
                        }
                    }
                    .tags {
                        display: flex;
                        flex-flow: wrap;
                        margin-bottom: 3px;
                        .tag_item {
                            margin: 2px 0 2px 5px;
                            border: none;
                            background: #EBEEF5;
                            color: #606266;

                        }
                        .button-new-tag {
                            margin: 2px 0 2px 5px;
                            padding-top: 5px;
                            padding-bottom: 5px;
                        }
                        .input-new-tag {
                            margin: 0 0 0 5px;
                            width: 90px;
                            vertical-align: bottom;
                            height: 28px;
                        }
                    }
                    .input_num {
                        cursor: pointer;
                    }
                }
                .bottom_flex {
                    margin-bottom: 5px;
                }
                .date {
                    font-size: 0.875rem;
                    color: #8d8d8d;
                    padding: 0 10px;
                }
            }

        }
        .bottom_page {
            flex: 0 0 50px;
            box-sizing: border-box;
            padding-top: 10px;
            width: 100%;
            text-align: center;
        }
    }
</style>
<style lang="scss">
    .tag_item {
        .el-tag__close {
            color: #606266;
            &:hover {
                color: #FFF;
                background-color: #606266;
            }
        }
    }

</style>